import React, { useMemo } from 'react';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import { CardBrands } from 'types';
import { cardBrands } from 'appConstants';
import { Rule } from 'antd/lib/form';
import { IExtraPaymentType } from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/editRestaurantState/editRestaurantContext';

interface IExtraCardBrandSelect {
	extraPaymentType: IExtraPaymentType;
	changeCardBrand: (value: CardBrands) => void;
	selectedCardBrands: CardBrands[];
	validationRules: Rule[];
}

const ExtraCardBrandSelect: React.FC<IExtraCardBrandSelect> = ({
	extraPaymentType,
	selectedCardBrands,
	changeCardBrand,
	validationRules,
}) => {
	const mappedOptions = useMemo<ISelectOption[]>(
		() =>
			cardBrands.map((el) => {
				return {
					id: el.id,
					name: el.name,
					disabled: selectedCardBrands.includes(el.id) && el.id !== extraPaymentType.brand,
				};
			}),
		[selectedCardBrands, extraPaymentType.brand],
	);

	return (
		<FormSelect
			testId="ExtraCardBrandSelect"
			name={`extraCardBrand-${extraPaymentType.id}`}
			label="cardBrandLabel"
			options={mappedOptions}
			onChange={changeCardBrand}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ExtraCardBrandSelect);
